export default __webpack_public_path__ + "static/graphic-experiments-d911a1bb264f82144341b2f51a54d529.svg";